<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Pliki</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Pliki</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Pliki</h5>
            <span class="ibox-toggle" @click="isMainOpen = !isMainOpen">
              <i :class="chevronMainClass"></i>
            </span>
          </div>
          <div class="ibox-content" v-show="isMainOpen">
            <router-link v-if="canAddFile" to="/file/create">
              <button class="btn btn-sm btn-primary">Dodaj</button>
            </router-link>
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @change="setRowsPerPage"
                      @click="isSearch = false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option :value="rowsPerPage">
                        {{ rowsPerPage }}
                      </option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items"
                  :clickRowToExpand="true"
                  :loading="loading"
                  @expand-row="editFiles"
                  alternating
                  multi-sort
                  show-index
                  border-cell
                  @update-sort="updateSort"
                  class="table-search"
                >
                  <template #header="header">
                    <span v-if="header.text">{{ header.text }}</span>
                    <input
                      class="table-search"
                      type="text"
                      v-if="header.search"
                      v-model="searchValue[header.value]"
                      @keyup="search"
                      @click="isSearch = true"
                    />
                  </template>
                  <template #expand>
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis pliku [pl]</h5>
                            <span
                              class="ibox-toggle"
                              @click="isPlOpen = !isPlOpen"
                            >
                              <i :class="chevronPlClass"></i>
                            </span>
                          </div>
                          <div class="ibox-content" v-show="isPlOpen">
                            <div class="form-horizontal">
                              <div class="ibox-content">
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Nazwa
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="fileObj.name_pl"
                                      name="name"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Nazwa"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.name_pl"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.name_pl[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis pliku [en]</h5>
                            <span
                              class="ibox-toggle"
                              @click="isEnOpen = !isEnOpen"
                            >
                              <i :class="chevronEnClass"></i>
                            </span>
                          </div>
                          <div class="ibox-content" v-show="isEnOpen">
                            <div class="form-horizontal">
                              <div class="ibox-content">
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Nazwa
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="fileObj.name_en"
                                      name="name"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Tytuł"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.name_en"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.name_en[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis pliku [de]</h5>
                            <span
                              class="ibox-toggle"
                              @click="isDeOpen = !isDeOpen"
                            >
                              <i :class="chevronDeClass"></i>
                            </span>
                          </div>
                          <div class="ibox-content" v-show="isDeOpen">
                            <div class="form-horizontal">
                              <div class="ibox-content">
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Nazwa
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="fileObj.name_de"
                                      name="name"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Nazwa"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.name_de"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.name_de[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis pliku [de_de]</h5>
                            <span
                              class="ibox-toggle"
                              @click="isDeDeOpen = !isDeDeOpen"
                            >
                              <i :class="chevronDeDeClass"></i>
                            </span>
                          </div>
                          <div class="ibox-content" v-show="isDeDeOpen">
                            <div class="form-horizontal">
                              <div class="ibox-content">
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Nazwa
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="fileObj.name_cpde"
                                      name="name"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Nazwa"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.name_cpde"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.name_cpde[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis pliku [de_en]</h5>
                            <span
                              class="ibox-toggle"
                              @click="isDeEnOpen = !isDeEnOpen"
                            >
                              <i :class="chevronDeEnClass"></i>
                            </span>
                          </div>
                          <div class="ibox-content" v-show="isDeEnOpen">
                            <div class="form-horizontal">
                              <div class="ibox-content">
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Nazwa
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="fileObj.name_cpen"
                                      name="name"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Tytuł"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.name_cpen"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.name_cpen[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis pliku [de_fr]</h5>
                            <span
                              class="ibox-toggle"
                              @click="isDeFrOpen = !isDeFrOpen"
                            >
                              <i :class="chevronDeFrClass"></i>
                            </span>
                          </div>
                          <div class="ibox-content" v-show="isDeFrOpen">
                            <div class="form-horizontal">
                              <div class="ibox-content">
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Nazwa
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="fileObj.name_cpen"
                                      name="name"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Tytuł"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.name_cpen"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.name_cpen[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Konfiguracja pliku</h5>
                            <span
                              class="ibox-toggle"
                              @click="isConfigOpen = !isConfigOpen"
                            >
                              <i :class="chevronConfigClass"></i>
                            </span>
                          </div>
                          <div class="ibox-content" v-show="isConfigOpen">
                            <div class="form-horizontal">
                              <div class="ibox-content">
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Plik
                                  </label>
                                  <div class="col-sm-10">
                                    <div class="form-control filename">
                                      <span
                                        v-if="fileObj.file_name"
                                        class="filename"
                                      >
                                        {{ fileObj.file_name }}
                                      </span>
                                      <input
                                        type="file"
                                        name="file"
                                        v-on:change="onFileChange"
                                        multiple="multiple"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div
                                  v-if="typeof fileObj.file === 'string'"
                                  class="form-group"
                                >
                                  <div class="col-sm-10 col-sm-offset-2">
                                    <a
                                      :href="fileObj.file"
                                      target="_blank"
                                      class="btn btn-default btn-sm"
                                    >
                                      <font-awesome-icon icon="download" />
                                      Pobierz aktualny plik
                                    </a>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <div class="col-sm-4 col-sm-offset-2">
                                    <button
                                      class="btn btn-white"
                                      @click="cancel"
                                    >
                                      Anuluj
                                    </button>
                                    <button
                                      v-if="canChangeFile"
                                      @click="saveEdit"
                                      class="btn btn-primary"
                                    >
                                      Zapisz
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #item-title="item">
                    {{ item.title_pl }}
                  </template>
                  <template #item-content="item">
                    {{ item.content_pl }}
                  </template>
                  <template #item-actions="item">
                    <button
                      v-if="canDeleteFile"
                      @click.stop="
                        showModal = item.pk;
                        deleteName = item.name;
                      "
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </template>
                </EasyDataTable>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Modal
    v-if="showModal"
    :title="'Potwierdzenie usunięcia'"
    :content="'Czy na pewno chcesz usunąć <b>' + deleteName + '</b> ?'"
    @callbackOk="deleteFiles(showModal)"
    @callbackClose="showModal = false"
  />
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";
import Modal from "../caffeprint/Modal.vue";
import { hasPermission } from "../../permissions";
import { filePermissionsConst } from "../../constants/fileConstants";

export default {
  name: "FilesList",
  mixins: [],
  components: {
    Modal,
  },
  props: {},

  setup() {
    const store = useStore();
    const deleteFilesData = computed(() => store.getters.getDeleteFilesData);
    const filesData = computed(() => store.getters.getFileData);
    const updateFilesData = computed(() => store.getters.getUpdateFilesData);
    const filesListData = computed(() => store.getters.getFilesData);
    const canAddFile = computed(() => hasPermission(filePermissionsConst.add));
    const canChangeFile = computed(() =>
      hasPermission(filePermissionsConst.update)
    );
    const canDeleteFile = computed(() =>
      hasPermission(filePermissionsConst.delete)
    );

    let headers = [
      { text: "ID", value: "pk", search: true, sortable: true },
      { text: "Nazwa", value: "name", search: true, sortable: true },
      { text: "Link", value: "file", search: true, sortable: true },
      { text: "Data dodania", value: "date_added", sortable: true },
      { text: "Data modyfikacji", value: "date_modified", sortable: true },
      {
        text: "Zmodyfikowano przez",
        value: "last_modified_by",
        sortable: false,
      },
      {
        text: "Utworzono przez",
        value: "created_by",
        sortable: false,
      },
      { text: "Akcje", value: "actions" },
    ];
    const fileObj = ref({
      name_pl: "",
      name_en: "",
      name_de: "",
      name_cpde: "",
      name_cpen: "",
    });

    let items = ref([]);
    let itemsAll = ref(0);
    const showModal = ref(false);
    const deleteName = ref("");
    const publication_date = ref();
    const loading = ref(true);
    const searchValue = ref({});
    const isSearch = ref(false);
    const rowsPerPage = ref();
    const defRowsPerPage = ref(25);
    const serverOptions = ref({
      page: 1,
      rowsPerPage: defRowsPerPage.value,
    });

    const isMainOpen = ref(true);
    const isPlOpen = ref(true);
    const isEnOpen = ref(true);
    const isDeOpen = ref(true);
    const isDeDeOpen = ref(true);
    const isDeEnOpen = ref(true);
    const isDeFrOpen = ref(true);
    const isConfigOpen = ref(true);

    const chevronMainClass = computed(() =>
      isMainOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronPlClass = computed(() =>
      isPlOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronEnClass = computed(() =>
      isEnOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronDeClass = computed(() =>
      isDeOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronDeDeClass = computed(() =>
      isDeDeOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronDeEnClass = computed(() =>
      isDeEnOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronDeFrClass = computed(() =>
      isDeFrOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronConfigClass = computed(() =>
      isConfigOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );

    const getFiles = async () => {
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      await store.dispatch("getFiles", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
      });
    };

    const format = (date) => {
      let day, month, year, hours, minutes, seconds;
      day = date.getDate();
      month = ("0" + (date.getMonth() + 1)).slice(-2);
      year = date.getFullYear();
      minutes = ("0" + date.getMinutes()).slice(-2);
      seconds = ("0" + date.getSeconds()).slice(-2);
      hours = date.getHours();

      return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
    };

    const deleteFiles = (pk) => {
      showModal.value = false;

      if (!canDeleteFile.value) {
        return;
      }

      store.dispatch("deleteFile", {
        pk: pk,
      });
    };
    const saveEdit = () => {
      if (!canChangeFile.value) {
        return;
      }

      if (typeof fileObj.value.file == "string") {
        delete fileObj.value.file;
      }
      store.dispatch("updateFiles", fileObj.value);
    };

    const cancel = () => {
      document.querySelector(".expanding")?.click();
    };

    const editFiles = (globalIndex) => {
      cancel();
      const localIndex =
        globalIndex - (serverOptions.value.page - 1) * defRowsPerPage.value;
      store.dispatch("getFile", { pk: items.value[localIndex].pk });
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        selectPage(1);
        setTimeout(() => {
          getFiles();
          isSearch.value = false;
        }, 1000);
      }
    };

    const resetFilters = () => {
      searchValue.value = {};
      serverOptions.value.sortBy = "";
      getFiles();
    };

    const updateSort = () => {
      search.value = true;
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const onFileChange = (e) => {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      fileObj.value.file = files[0];
    };

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };

    onMounted(() => {
      if (localStorage.getItem("filesSearchValue") !== null) {
        searchValue.value = localStorage.getItem("filesSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }
      getFiles();
    });

    watch(
      () => searchValue.value,
      function () {
        localStorage.setItem(
          "filesSearchValue",
          JSON.stringify(searchValue.value)
        );
        getFiles();
      },
      { deep: true }
    );

    watch(
      () => filesListData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
        });
        loading.value = false;
      }
    );

    watch(
      () => filesData.value,
      function (newValue) {
        fileObj.value = newValue.data;
      }
    );

    watch(
      () => deleteFilesData.value,
      function (newValue) {
        if (newValue.status === 204) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Plik został usunięty",
          });
        }
        getFiles();
      }
    );

    watch(
      () => updateFilesData.value,
      function (newValue) {
        if (newValue.status === 200) {
          getFiles();
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane zostały zaktualizowane",
          });
        }

        cancel();
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getFiles();
          isSearch.value = false;
        }
      },
      { deep: true }
    );

    return {
      headers,
      items,
      itemsAll,
      loading,
      canAddFile,
      canChangeFile,
      canDeleteFile,
      serverOptions,
      showModal,
      deleteFiles,
      deleteName,
      fileObj,
      cancel,
      editFiles,
      saveEdit,
      publication_date,
      format,
      searchValue,
      search,
      resetFilters,
      updateSort,
      isSearch,
      rowsPerPage,
      onFileChange,
      selectPage,
      setRowsPerPage,
      isMainOpen,
      isPlOpen,
      isEnOpen,
      isDeOpen,
      isDeDeOpen,
      isDeEnOpen,
      isDeFrOpen,
      isConfigOpen,
      chevronMainClass,
      chevronPlClass,
      chevronEnClass,
      chevronDeClass,
      chevronDeDeClass,
      chevronDeEnClass,
      chevronDeFrClass,
      chevronConfigClass,
    };
  },
  computed: {},
};
</script>

<style scoped>
.ibox-title {
  position: relative;
}
.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 12px;
  cursor: pointer;
}
</style>
